import { render, staticRenderFns } from "./RflmCalculatingChildSupport.vue?vue&type=template&id=9d1981ac"
import script from "./RflmCalculatingChildSupport.vue?vue&type=script&lang=ts"
export * from "./RflmCalculatingChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports